import { LayaGL } from "../../../../layagl/LayaGL";
import { ShaderCompile } from "../../../../webgl/utils/ShaderCompile";
export class ComputeShader {
    static createComputeShader(name, code, other) {
        if (!ComputeShader._CompileShader[name]) {
            return new ComputeShader(name, ShaderCompile.compileCompute(code), other);
        }
        else
            return ComputeShader._CompileShader[name];
    }
    constructor(name, node, uniformMaps) {
        this._cacheSharders = {};
        this._cacheShaderHierarchy = 1;
        this.name = name;
        this.node = node.node;
        this.uniformMaps = uniformMaps.slice();
    }
    setCacheShader(compileDefine, shader) {
        var cacheShaders = this._cacheSharders;
        var mask = compileDefine._mask;
        var endIndex = compileDefine._length - 1;
        var maxEndIndex = this._cacheShaderHierarchy - 1;
        for (var i = 0; i < maxEndIndex; i++) {
            var subMask = endIndex < i ? 0 : mask[i];
            var subCacheShaders = cacheShaders[subMask];
            (subCacheShaders) || (cacheShaders[subMask] = subCacheShaders = {});
            cacheShaders = subCacheShaders;
        }
        var cacheKey = endIndex < maxEndIndex ? 0 : mask[maxEndIndex];
        cacheShaders[cacheKey] = shader;
    }
    getCacheShader(compileDefine) {
        var cacheShaders = this._cacheSharders;
        var maskLength = compileDefine._length;
        if (maskLength > this._cacheShaderHierarchy) {
            this._resizeCacheShaderMap(cacheShaders, 0, maskLength);
            this._cacheShaderHierarchy = maskLength;
        }
        var mask = compileDefine._mask;
        var endIndex = compileDefine._length - 1;
        var maxEndIndex = this._cacheShaderHierarchy - 1;
        for (var i = 0; i < maxEndIndex; i++) {
            var subMask = endIndex < i ? 0 : mask[i];
            var subCacheShaders = cacheShaders[subMask];
            (subCacheShaders) || (cacheShaders[subMask] = subCacheShaders = {});
            cacheShaders = subCacheShaders;
        }
        var cacheKey = endIndex < maxEndIndex ? 0 : mask[maxEndIndex];
        var shader = cacheShaders[cacheKey];
        if (!shader) {
            shader = LayaGL.renderDeviceFactory.createComputeShader({
                name: this.name,
                node: this.node,
                uniformMaps: this.uniformMaps,
                defineData: compileDefine
            });
            this.setCacheShader(compileDefine, shader);
        }
        return shader;
    }
    _resizeCacheShaderMap(cacheMap, hierarchy, resizeLength) {
        var end = this._cacheShaderHierarchy - 1;
        if (hierarchy == end) {
            for (var k in cacheMap) {
                var shader = cacheMap[k];
                for (var i = 0, n = resizeLength - end; i < n; i++) {
                    if (i === n - 1)
                        cacheMap[0] = shader;
                    else
                        cacheMap = cacheMap[i == 0 ? k : 0] = {};
                }
            }
        }
        else {
            ++hierarchy;
            for (var k in cacheMap)
                this._resizeCacheShaderMap(cacheMap[k], hierarchy, resizeLength);
        }
    }
}
ComputeShader._CompileShader = {};
